export default __webpack_public_path__ + "static/mobile-image-d779a6d822810444a82f4d9615eeb83b.jpg";